import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { Box, Heading, Flex, Text } from "rebass/styled-components";
import Wrapper from "../Wrapper";
import Card from "../../UI/Card";
import Modal from "../../UI/Modal";

const EssencesBois = ({ data }) => {
  const [selectedEssence, setSelectedEssence] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const essencesData = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/essences-bois/" } }
        sort: { fields: [frontmatter___ordre], order: ASC }
      ) {
        edges {
          node {
            id
            frontmatter {
              titre
              image {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    src
                  }
                }
              }
              description
              conseils
              avantages
              applications
              ordre
            }
          }
        }
      }
    }
  `);

  const essences = essencesData.allMarkdownRemark.edges;

  const handleCardClick = essence => {
    setSelectedEssence(essence);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Wrapper data={data}>
      <Box>
        <Flex flexWrap="wrap" mx={-3}>
          {essences.map((essence, i) => (
            <Box key={essence.node.id} width={[1, 1 / 2, 1 / 3]} p={3} mb={4}>
              <Box
                onClick={() => handleCardClick(essence.node)}
                sx={{ 
                  cursor: "pointer",
                  transition: "transform 0.2s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-5px)"
                  }
                }}
              >
                <Card
                  isVertical={true}
                  title={essence.node.frontmatter.titre}
                  image={essence.node.frontmatter.image?.childImageSharp?.fluid?.src || ""}
                  content={essence.node.frontmatter.description.substring(0, 100) + "..."}
                />
              </Box>
            </Box>
          ))}
        </Flex>
      </Box>

      {isModalOpen && selectedEssence && (
        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <Box p={4}>
            <Heading as="h2" mb={3}>
              {selectedEssence.frontmatter.titre}
            </Heading>
            
            <Flex flexWrap="wrap" mb={4}>
              <Box width={[1, 1 / 3]} pr={[0, 4]} mb={[4, 0]}>
                <Box
                  width="100%"
                  height="300px"
                  sx={{
                    backgroundImage: `url(${selectedEssence.frontmatter.image?.childImageSharp?.fluid?.src || ""})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                  }}
                />
              </Box>
              
              <Box width={[1, 2/3]}>
                <Text mb={3}>{selectedEssence.frontmatter.description}</Text>
                
                <Heading as="h4" mb={2}>
                  Conseils d&apos;entretien
                </Heading>
                <Box mb={3}
                  dangerouslySetInnerHTML={{ __html: selectedEssence.frontmatter.conseils }}
                />
                
                <Heading as="h4" mb={2}>
                  Avantages
                </Heading>
                <Box as="ul" mb={3}>
                  {selectedEssence.frontmatter.avantages.map((avantage, i) => (
                    <Box as="li" key={i} mb={1}>
                      {avantage}
                    </Box>
                  ))}
                </Box>
                
                <Heading as="h4" mb={2}>
                  Applications
                </Heading>
                <Box as="ul">
                  {selectedEssence.frontmatter.applications.map((application, i) => (
                    <Box as="li" key={i} mb={1}>
                      {application}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Flex>
          </Box>
        </Modal>
      )}
    </Wrapper>
  );
};

EssencesBois.propTypes = {
  data: PropTypes.object
};

export default EssencesBois;
